export const fr = {
    common: {
        aloapp: "aloPay est un moyen pratique, rapide et abordable d'effectuer des paiements, de gérer les clients et de générer des factures.",
        offer: "La plateforme offre :",
        easyPayment: "Traitement facile des",
        processing: "Paiements",
        invoiceGe: "Génération de factures",
        receiptsGe: "Génération de recettes",
        our: "Notre",
        solution: "Solution",
        processPay: "Traitez les paiements de manière transparente pour toutes les factures. Intégrer des passerelles de paiement sécurisées pour collecter les paiements directement auprès des clients.",
        home: "Mise en place de l'intégration des paiements et de la facturation",
        control: "De la gestion client au flux de trésorerie : une seule plateforme pour un contrôle total.",
        explore: "Explorer la plateforme",
        why: "Pourquoi choisir",
        handle: "Gérez vos paiements, vos comptes et vos clients en un seul endroit.",
        digital: "Passez au numérique, créez, envoyez facilement les paiements en temps réel, réduisez les erreurs manuelles et accélérez les cycles de paiement.",
        easy: "Traitement facile des paiements",
        process: "Traitez les paiements de manière transparente pour toutes les factures.",
        integrate: "Intégration possible avec des plateformes de paiement sécurisées pour recevoir les paiements de vos clients.",
        secure: "Sécurisé",
        local: "Monnaie locale",
        payout_number: "Numéro de paiement (0551611100)",
        enter_account: "Saisir le nom du compte",
        momo: "Numéro Momo",
        momo_name: "Nom de Momo",
        provider: "Nom du prestataire",
        select_provider: "Sélectionner le fournisseur",
        real: "Analyse en temps réel",
        provide: "Fournit une vue d'ensemble des activites financières et une analyse détaillée de l'ensemble de vos factures, du montant gagné et de l'historique.",
        instant: "transfert instantané",
        analytics: "rapport analytique",
        insights: "détails",
        time: "en temps réel",
        safe: "Protection et sécurité",
        keep: "Protégez vos factures et les informations de vos clients grâce à notre plateforme sécurisée. Accédez à vos données à tout moment et en tout lieu.",
        cloud: "cloud",
        encrypt: "crypté",
        login: "Se connecter / S'inscrire",
        welcome: "Bienvenue !",
        log: "Connectez-vous ou créez un compte pour commencer.",
        success: "succès !",
        successful: "Connexion réussie !",
        sign: "Connectez-vous avec vos données d'identification",
        forgot: " Mot de passe oublié ?",
        create: " Créer un nouveau compte",
        signin: " S'inscrire",
        register: "Inscription réussie !",
        registration: "L'enregistrement a échoué - veuillez réessayer !",
        error: "Erreur",
        name: "Nom",
        email: "Email",
        company: "Nom de l'entreprise",
        phone: "Téléphone",
        password: "Mot de passe",
        upload: "Télécharger le logo",
        account: "créer un compte",
        loggin: "Connexion",
        wrong: "Mauvaise adresse email ou mauvais mot de passe !",
        language: "Langue",
        request: "Demande de réinitialisation du mot de passe",
        reset: "Réinitialiser le mot de passe !",
        match: "Les mots de passe ne correspondent pas.",
        reset_success: "Le mot de passe a été réinitialisé avec succès.",
        reset_fail: "Échec de la réinitialisation du mot de passe.",
        enter: "Entrez votre nouveau mot de passe",
        password_sent: "Lien de réinitialisation du mot de passe envoyé à votre adresse email.",
        password_failed: "Le lien de réinitialisation du mot de passe n'a pas été envoyé.",
        enter_mail: "Saisissez votre adresse email",
        request_reset: " Demande de réinitialisation",
        terms: "Termes et Conditions",
        privacy: "Politique de Confidentialité",
        commission: "La Commission",
        alovroom: "Recettes d'Alovroom"

    },

    sidenav: {
        dash: "Tableau de bord",
        profile: "Profil",
        add_user: "Ajouter un utilisateur",
        category: "Catégories",
        add_category: "Ajouter une catégorie",
        product: "Produits",
        add_product: "Ajouter un produit",
        customer: "Clients",
        add_customer: "Ajouter un client",
        invoice: "Factures",
        add_invoice: "Ajouter une facture",
        accounts: "Comptes",
        wallet: "Portefeuille"
    },

    dashboard: {
        invoice: "Facture complétée",
        details: "voir les détails",
        users: "Utilisateurs",
        customers: "Clients",
        products: "Produits",
        dash: "Tableau de bord",
        profile: "Mon profil",
        logout: "Déconnexion"

    },

    profile: {
        management: "Gestion des profils",
        adduser: "Ajouter un utilisateur",
        name: "Nom",
        profile: "Profils",
        phone: "Téléphone",
        edituser: "Modifier l'utilisateur",
        deleteuser: "Supprimer un utilisateur",
        success: "succès !",
        userupdated: " Utilisateur mis à jour",
        failed: "Échec de la mise à jour de l'utilisateur",
        submit: "soumettre",
        cancel: "Annuler",
        error: "Erreur",
        sure: "Êtes-vous sûr ?",
        successful: "Création d'un utilisateur réussie !",
        not_successful: "La création d'un utilisateur a échoué - veuillez réessayer !",
        delete_text: "Vous ne pourrez pas revenir en arrière !",
        delete_confirm: "Oui, supprimez-la !",
        delete_error_title: "Échec de la suppression de l'utilisateur. Veuillez réessayer.",
        delete_success_message: "Votre utilisateur a été supprimé.",
        delete_success_title: "Supprimé"


    },

    category: {
        sure: "Êtes-vous sûr ?",
        delete_text: "Vous ne pourrez pas revenir en arrière !",
        delete_confirm: "Oui, supprimez-la !",
        delete_category: "Supprimer la catégorie",
        delete_error_title: "Une erreur inattendue s'est produite. Veuillez réessayer.",
        management: "Catégories Gestion",
        not_successful: "La création d'un utilisateur a échoué - veuillez réessayer !",
        add_category: "Ajouter une catégorie",
        cat: "Catégorie",
        edit_category: "Modifier la catégorie",
        updated: "Catégorie mise à jour",
        failed: "Catégorie Mise à jour échouée",
        search: "Catégories de recherche",
        edit_category_details: "Modifier les détails de la catégorie",
        successful: " Catégories création Succès !",
        remove: "Retirer",
        add_another: " Ajouter une autre catégorie",
        category_name: "Nom de la catégorie"


    },

    product: {
        not_successful: "Échec de la suppression du produit. Veuillez réessayer.",
        delete: "Supprimé",
        deleted: "Votre produit a été supprimé.",
        management: "Gestion des produits",
        products: "Produits",
        add_products: "Ajouter des produits",
        search: "Rechercher des produits...",
        product_name: "Nom du produit",
        quantity: "Quantité",
        price: "Prix",
        // delete: "Supprimer un produit",
        edit: "Modifier le produit",
        edit_details: "Modifier les détails du produit",
        product_updated: "Produit mis à jour",
        failed: " Échec de la mise à jour du produit",
        details: "Détails",
        seterror: "La catégorie est requise pour chaque produit et la quantité doit être non négative.",
        select: "Sélectionner une catégorie",
        add_another: "Ajouter un autre produit",
        successful: "Création de produits réussie !",
        not_successfull: "La création du produit a échoué - veuillez réessayer !"
    },

    customer: {
        not_successful: "La suppression du client a échoué. Veuillez réessayer.",
        deleted: "Votre client a été supprimé.",
        customers: "Clients",
        management: "Gestion des clients",
        add_customer: "Ajouter un client",
        address: "Adresse",
        country: "Pays",
        edit_customer: "Modifier le client",
        edit_customer_details: "Modifier les détails du client",
        updated: "Client mis à jour",
        successful: "Création d'un client réussie !",
        not_successful: "La création d'un client a échoué - veuillez réessayer !",
        town: "Ville",
        add_another: "Ajouter un autre client",
        select: "Sélectionner un pays",
        search: "Rechercher des clients..."

    },

    invoice: {
        invoices: "Factures",
        management: "Gestion des factures",
        payment_confrim: "Confirmation de paiement",
        proceed: "Cliquer pour payer maintenant",
        pay_now: "Payer maintenant avec PawaPay",
        pay_now_stack: "Payer maintenant avec Paystack",
        proccessed: "Le paiement sera effectué dans le GHS",
        equivalent: "Équivalent",
        add_invoice: "Ajouter une facture",
        payment_success: "Le statut du paiement a été mis à jour avec succès",
        not_updated: "L'état des paiements n'est pas mis à jour",
        search: "Recherche de factures...",
        searchUser: "Recherche de Utilisateurs...",
        filter: "Filter",
        customer_name: "Nom du client",
        customer_country: "Pays du client",
        customer_address: "Adresse du client",
        customer_email: "Email du client",
        customer_phone: "Téléphone du client",
        invoice_date: "Date de la facture",
        customer_product_name: "Nom du produit",
        quantity: "Quantité",
        price: "Prix",
        discount: "Remise",
        subtotal: "Sous-total",
        status: "Statut",
        paid: "Payé",
        clear:"clair",
        not_paid: "Non payé",
        edit_invoice: "Modifier la facture",
        edit_invoice_details: "Modifier les détails de la facture",
        delete_invoice: "Supprimer la facture",
        payment_link: "Envoyer le lien de paiement",
        send_receipt: "Envoyer l'accusé de réception",
        print_invoice: "Imprimer la facture",
        updated: "Facture mise à jour",
        not_updatedd: "Échec de la mise à jour de la facture",
        link_sent: "Envoi du lien de paiement",
        link_not__sent: "Email erroné ou lien déjà envoyé",
        to: "Pour",
        submitting: "Soumettre...",
        receipt_sent: "Accusé de réception envoyé",
        receipt_not_sent: "Mauvais email ou email déjà envoyé",
        not_successfull: "La suppression de la facture a échoué. Veuillez réessayer.",
        deleted: "Votre facture a été supprimée.",
        select_customer: "Sélectionner un client",
        select_product: "Sélectionner un produit",
        successfull: "Création de la facture réussie !",
        not_successful: "La création de la facture a échoué - veuillez réessayer !",
        loading: "Chargement de la facture...",
        error_invoice: "Erreur de chargement de la facture",
        retry: "Réessayer",
        not_found: "Facture introuvable",
        not_be_found: "La facture demandée n'a pas été trouvée.",
        choosing: "Merci de nous avoir choisis,",
        location: "Localisation :",
        amount: "Montant",
        initiate: "Initier le paiement",
    },



    wallet: {

        balance: "Équilibre du portefeuille",
        setup: "Mise en place du portefeuille",
        banks: "Sélectionner la banque",
        select_bank: "Sélectionner une banque",
        account_number: "Numéro de compte",
        veirfy: "Vérifier",
        account_name: "Nom du compte",
        setup_wallet: "Mise en place du portefeuille",
        withdrawal: "Demande de retrait",
        amount: "Montant",
        request: "Demande de retrait",
        withdrawal_request: "Demandes de retrait",
        bank: "Banque",
        status: "Statut",
        no_withdrawall: "Aucune demande de retrait trouvée",
        valid: "Veuillez saisir un numéro de compte valide et sélectionner une banque.",
        wrong: "Mauvais compte ou banque",
        verified: "Vérifié",
        verify_account: "Veuillez d'abord vérifier votre numéro de compte",
        wallet_setup: "Installation du portefeuille réussie !",
        insufficient: "Solde insuffisant",
        wallet: "Portefeuille"
    },





};